import {
  ApplicationConfig,
  importProvidersFrom,
  provideZoneChangeDetection,
  provideAppInitializer,
  inject,
} from '@angular/core';
import { provideRouter } from '@angular/router';
import { BriefcaseMedical, ChevronRight, CircleUser, Facebook, Grip, HeartHandshake, HeartPulse, Instagram, Linkedin, LucideAngularModule, MessageCircle, Twitter, UserStar, CircleCheck, CircleCheckBig, Circle, BookOpenText, HeartPlus, Info, HandHeart, BookHeart, Church, BookUser, Stethoscope, Ambulance, UserPlus, UserMinus, CircleFadingPlus, Tickets, Trash2, CircleUserRound, FileUser, FileUp, CreditCard, Wallet, Banknote, Leaf, Lock, ClipboardList, CheckCircle, Gem, AlertTriangle, Receipt, ShieldCheck, Shield, TriangleAlert, CircleAlert, House, Calendar, AlertCircle, CircleArrowDown, CircleArrowUp } from 'lucide-angular';

import { routes } from './app.routes';
import { httpInterceptorProviders } from './core/data/interceptors';
import {
  provideHttpClient,
  withInterceptorsFromDi,
} from '@angular/common/http';
import { AuthService } from './features/auth/services/auth.service';
import {
  BrowserCacheLocation,
  InteractionType,
  IPublicClientApplication,
  LogLevel,
  PublicClientApplication,
} from '@azure/msal-browser';
import {
  MSAL_GUARD_CONFIG,
  MSAL_INSTANCE,
  MSAL_INTERCEPTOR_CONFIG,
  MsalBroadcastService,
  MsalGuard,
  MsalGuardConfiguration,
  MsalInterceptorConfiguration,
  MsalService,
} from '@azure/msal-angular';
import { environment } from '../environments/environment';
import { provideEnvironmentNgxMask } from 'ngx-mask';
import { ExchangeRateService } from './core/data/services/exchange-rate.service';

export function loggerCallback(logLevel: LogLevel, message: string) { }

export function MSALInstanceFactory(): IPublicClientApplication {
  return new PublicClientApplication({
    auth: {
      clientId: environment.msalConfig.auth.clientId,
      authority: environment.b2cPolicies.authorities.signUpSignIn.authority,
      redirectUri: '/',
      postLogoutRedirectUri: '/',
      knownAuthorities: [environment.b2cPolicies.authorityDomain],
    },
    cache: {
      cacheLocation: BrowserCacheLocation.LocalStorage,
    },
    system: {
      loggerOptions: {
        loggerCallback,
        logLevel: LogLevel.Verbose,
        piiLoggingEnabled: false,
      },
    },
  });
}

export function MSALInterceptorConfigFactory(): MsalInterceptorConfiguration {
  const protectedResourceMap = new Map<string, Array<string>>();

  protectedResourceMap.set(
    environment.apiConfig.uri,
    environment.apiConfig.scopes,
  );

  return {
    interactionType: InteractionType.Redirect,
    protectedResourceMap,
  };
}

export function MSALGuardConfigFactory(): MsalGuardConfiguration {
  return {
    interactionType: InteractionType.Redirect,
    authRequest: {
      scopes: [...environment.apiConfig.scopes],
    },
    loginFailedRoute: '/auth/login-failed',
  };
}

export const appConfig: ApplicationConfig = {
  providers: [
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideAppInitializer(() => inject(ExchangeRateService).loadRateOnStartup()),
    provideRouter(routes),
    provideHttpClient(withInterceptorsFromDi()),
    httpInterceptorProviders,
    AuthService,
    provideEnvironmentNgxMask(),
    importProvidersFrom(LucideAngularModule.pick({
      Grip,
      CircleUser,
      HeartHandshake,
      HeartPulse,
      BriefcaseMedical,
      ChevronRight,
      UserStar,
      Facebook,
      Instagram,
      Linkedin,
      Twitter,
      MessageCircle,
      CircleCheck,
      Circle,
      CircleCheckBig,
      BookOpenText,
      HeartPlus,
      Info,
      HandHeart,
      BookHeart,
      Church,
      BookUser,
      Stethoscope,
      Ambulance,
      UserPlus,
      UserMinus,
      CircleFadingPlus,
      Tickets,
      Trash2,
      CircleUserRound,
      FileUser,
      FileUp,
      CreditCard,
      Wallet,
      Banknote,
      Leaf,
      Lock,
      ClipboardList,
      CheckCircle,
      Gem,
      AlertTriangle,
      Receipt,
      ShieldCheck,
      TriangleAlert,
      CircleAlert,
      House,
      Calendar,
      AlertCircle,
      Shield,
      CircleArrowDown, 
      CircleArrowUp
    })),
    {
      provide: MSAL_INSTANCE,
      useFactory: MSALInstanceFactory,
    },
    {
      provide: MSAL_GUARD_CONFIG,
      useFactory: MSALGuardConfigFactory,
    },
    {
      provide: MSAL_INTERCEPTOR_CONFIG,
      useFactory: MSALInterceptorConfigFactory,
    },
    MsalService,
    MsalGuard,
    MsalBroadcastService,
  ]
};
